var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){_vm.active = !_vm.active}}},[_vm._v("Tıkla")]),_c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"box"},[_vm._v("Fade test")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }